__turbopack_context__.v({
  "align-center": "hf9Mra_align-center",
  "align-left": "hf9Mra_align-left",
  "align-right": "hf9Mra_align-right",
  "headline-l": "hf9Mra_headline-l",
  "headline-m": "hf9Mra_headline-m",
  "headline-s": "hf9Mra_headline-s",
  "headline-xs": "hf9Mra_headline-xs",
});
